import { EventData } from 'utils/publicEvents/events';

export type Listener<T extends EventData = EventData> = {
  eventName: string;
  call: (data: T) => void;
};

const listeners: Listener[] = [];

const create = (eventName: string, callback: Listener['call']): Listener => ({
  eventName,
  call: callback,
});

const getByEventName = (eventName: string): Listener[] => {
  return listeners.filter((listener) => listener.eventName === eventName);
};

const getListeners = (): Listener[] => listeners;

const addListener = (listener: Listener): void => {
  listeners.push(listener);
};

const exportObject = {
  create,
  getByEventName,
  getListeners,
  addListener,
};

export default exportObject;
